<template>
  <nav
    data-testid="mobile-bar"
    class="fixed top-0 left-0 z-100 flex min-h-18 w-full items-center bg-linear-to-r from-depth-0 to-midnight px-4 py-4 shadow-2xl xl:hidden"
  >
    <button
      class="px-3 py-0 text-rhino"
      aria-label="Open Menu"
      type="button"
      @click.stop="emit('toggleMobileNavigation')"
    >
      <fa-icon :icon="faBars" class="size-5" />
    </button>

    <div class="flex grow">
      <nuxt-link
        class="mx-auto md:mx-0"
        :to="homepageUrl"
        :aria-label="t('general/menu/back-to-home')"
      >
        <common-gportal-logo class="h-6" />
      </nuxt-link>
    </div>

    <button
      v-if="authStore.isAuthenticated"
      class="px-3 py-0"
      :aria-label="t('profile/modal/switch_accounts')"
      type="button"
      @click="openUserSwitchModal"
    >
      <div class="relative">
        <common-avatar class="size-8" />
        <span
          class="absolute -right-2 bottom-0 rounded-sm bg-depth-0 px-1 py-0.5 text-xs leading-none"
        >
          {{ getRegionLabel(authStore.activeRegion) }}
        </span>
      </div>
    </button>

    <button
      v-else
      class="px-3 text-rhino"
      :aria-label="t('frontend/my-account')"
      type="button"
      @click="loginToAccount"
    >
      <fa-icon :icon="faUser" class="size-5" />
    </button>
  </nav>
</template>

<script setup lang="ts">
import { faBars, faUser } from '@fortawesome/pro-regular-svg-icons';
import useAuth from '~/composables/useAuth';
import useNavigationBasePages from './sidebar/features/useNavigationBasePages';
import { OPEN_MODAL_SYMBOL } from './symbols';

const emit = defineEmits<{
  (e: 'toggleMobileNavigation'): void;
}>();

const { t, locale } = useI18n();
const authStore = useAuthStore();
const { homepageUrl } = useNavigationBasePages();

const isModalOpen = inject(OPEN_MODAL_SYMBOL, ref(false));
const openUserSwitchModal = () => {
  isModalOpen.value = true;
};

const { login } = useAuth();
const loginToAccount = () => {
  login(`/${locale.value}/profile`);
};
</script>
